import { Box, Button, Card, CardHeader } from '@mui/material';
import React, { useState } from 'react';
import { Datagrid, List, Pagination, TextField } from 'react-admin';
import { Link } from 'react-router-dom';
import { ActionMenu } from '../../components/ActionMenu';
import { CustomSelectField } from '../../components/CustomSelectField';
import FullNameField from '../../components/FullNameField';
import { SelectFieldTeams } from '../../components/SelectFieldTeams';
import TextConcatenator from '../../components/TextConcatenator';

const CustomPagination = props => (
  <Pagination rowsPerPageOptions={[8, 16, 24]} {...props} />
);
export const MembersList = () => {
  const [teamSelected, setTeam] = useState('');
  const [selectedMember, setSelectedMember] = useState(null);

  const getResourceUrl = () => {
    if (selectedMember) {
      return `members?user_id=${selectedMember}`;
    }
    if (teamSelected) {
      return `members?team_id=${teamSelected}`;
    }
    return 'members';
  };

  const resourceUrl = getResourceUrl();

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px',
        borderRadius: '20px',
        marginTop: '16px',
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: '10px',
        }}
      >
        <CardHeader
          title="Miembros"
          sx={{
            padding: '0',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            'fieldset.MuiOutlinedInput-notchedOutline': {
              border: '1px solid rgba(0, 0, 0, 0.23) !important',
              borderRadius: '10px !important',
            },
            '.MuiOutlinedInput-root': {
              paddingTop: '0 !important',
            },
          }}
        >
          <SelectFieldTeams teamSelected={teamSelected} setTeam={setTeam} />
          <CustomSelectField
            value={selectedMember}
            filterTeam={teamSelected || null}
            setValue={setSelectedMember}
            field="members"
            label="Redactor"
          />
          <Button variant="contained" component={Link} to="/members/create">
            Nuevo miembro
          </Button>
        </Box>
      </Box>
      <List
        title={' '}
        perPage={8}
        actions={false}
        sort={{ field: 'first_name', order: 'DESC' }}
        sx={{
          border: 'none',
          '&:last-child th:last-of-type': { width: '40px' },
        }}
        // resource={`members${selectedMember ? `?user_id=${selectedMember}` : ''}${teamSelected && !selectedMember ? `?team_id=${teamSelected}` : ''}`}
        resource={resourceUrl}
        storeKey="members"
        pagination={
          <CustomPagination sort={{ field: 'first_name', order: 'DESC' }} />
        }
        disableSyncWithLocation
      >
        <Datagrid bulkActionButtons={false}>
          <FullNameField
            source="username"
            label="Nombre y apellido"
            sortBy={'first_name'}
          />
          <TextField source="email" label="Email" />
          <TextField source="external_id" label="External ID" />
          <TextConcatenator
            source="roles"
            attribute="title"
            label="Rol"
            sortable={false}
          />
          <TextConcatenator
            source="team_active"
            attribute="name"
            label="Equipo"
            sortable={false}
          />
          <ActionMenu resource="members" />
        </Datagrid>
      </List>
    </Card>
  );
};
